import { gql } from "@apollo/client";

export const GET_APP_FEATURE_BY_NAME = gql`
  query GetAppFeatureByName($name: String!) {
    appFeatureByName(featureName: $name) {
      id,
      name,
      appFeatureStatus,
    }
  }
`